// export const base_url = 'http://localhost:8000/'
export const base_url = 'https://api.housemasters.in/'